import { ArrowLeft, CheckCircle, Plug, Sparkles, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function GettingStarted() {
  return (
    <HelpArticle
      title="Getting Started"
      description="Set up RevUShield, connect your Google Business Profile, and start managing reviews."
    >
      <Step icon={Plug} title="1. Connect Google Business Profile">
        Connect the Google account that has access to the business profile you
        want to manage.
      </Step>

      <Step icon={CheckCircle} title="2. Confirm Business Details">
        Review the business name, location, and profile details pulled from
        Google.
      </Step>

      <Step icon={Sparkles} title="3. Generate Review Responses">
        RevUShield can suggest responses for new and existing reviews based on
        your preferences.
      </Step>

      <Step icon={Mail} title="4. Approve by Email or Dashboard">
        Review suggested responses, approve them, edit them, or reject them
        before posting.
      </Step>
    </HelpArticle>
  );
}

function HelpArticle({ title, description, children }) {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <Link
        to="/help"
        className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900"
      >
        <ArrowLeft size={16} />
        Back to Help
      </Link>

      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6 md:p-8">
        <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
        <p className="text-slate-500 mt-2">{description}</p>

        <div className="mt-8 space-y-4">{children}</div>
      </div>
    </div>
  );
}

function Step({ icon: Icon, title, children }) {
  return (
    <div className="border border-slate-200 rounded-2xl p-5 flex gap-4">
      <div className="h-11 w-11 rounded-xl bg-indigo-100 text-indigo-600 flex items-center justify-center shrink-0">
        <Icon size={21} />
      </div>

      <div>
        <h2 className="font-semibold text-slate-900">{title}</h2>
        <p className="text-sm text-slate-500 mt-1">{children}</p>
      </div>
    </div>
  );
}
